"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Rozszerz dataLayer GTMa o przekazane parametry
 * @param {Object} mapped
 */
exports.default = (function (mapped) {
    if (Object.keys(mapped).length > 0) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(mapped);
    }
});
